import { useGetList } from "ra-core";
import { useMemo } from "react";
import type { Company, Contact } from "../types";
import { EmailListSubscriptionsWidget } from "./EmailListSubscriptionsWidget";
import { extractEmailsFromContact } from "./encharge/api";

export const CompanyEmailListSubscriptions = ({
  record,
}: {
  record: Company;
}) => {
  const { data: contacts = [] } = useGetList<Contact>("contacts", {
    filter: { company_id: record.id },
    pagination: { page: 1, perPage: 500 },
    sort: { field: "last_name", order: "ASC" },
  });

  const emails = useMemo(
    () =>
      [
        ...new Set(
          contacts.flatMap((contact) =>
            extractEmailsFromContact(contact.email_jsonb),
          ),
        ),
      ],
    [contacts],
  );

  return (
    <EmailListSubscriptionsWidget
      emails={emails}
      companyName={record.name}
    />
  );
};
